module.exports = __webpack_public_path__ + "img/slide-28.e82d42ad.jpg";